import { render, staticRenderFns } from "./TeamMemberEditDialog.vue?vue&type=template&id=239a8bcc&scoped=true"
import script from "./TeamMemberEditDialog.vue?vue&type=script&lang=js"
export * from "./TeamMemberEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239a8bcc",
  null
  
)

export default component.exports